import CitySEOHead from "@/components/feature/CitySEOHead";
import CoralGablesHeroSection from "./components/HeroSection";
import CoralGablesStickyNav from "./components/StickyNav";
import CoralGablesProcessingTimeSection from "./components/ProcessingTimeSection";
import CoralGablesServicesSection from "./components/ServicesSection";
import CoralGablesLocalAreaSection from "./components/LocalAreaSection";
import CoralGablesTravelTimingSection from "./components/TravelTimingSection";
import CoralGablesDestinationsSection from "./components/DestinationsSection";
import CoralGablesTestimonialsSection from "./components/TestimonialsSection";
import CoralGablesAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CoralGablesComparisonSection from "./components/ComparisonSection";
import CoralGablesMistakesSection from "./components/MistakesSection";
import CoralGablesHowItWorksSection from "./components/HowItWorksSection";
import CoralGablesFAQSection, { faqs } from "./components/FAQSection";
import CoralGablesHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CoralGablesFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function CoralGablesPage() {
  return (
    <>
      <CitySEOHead
        city="Coral Gables"
        state="Florida"
        stateAbbr="FL"
        route="/cities/coral-gables"
        title="Emergency Passport Coral Gables, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Coral Gables, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Miami-Dade County travelers near MIA and Port of Miami."
        ogTitle="Emergency Passport Coral Gables, FL — Expedited & Fast Passport Service | Fast Passport Center"
        ogDescription="Emergency and expedited passport services in Coral Gables, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Miami-Dade County travelers near MIA and Port of Miami."
        twitterTitle="Emergency Passport Coral Gables, FL — Expedited & Fast Passport Service | Fast Passport Center"
        twitterDescription="Emergency and expedited passport services in Coral Gables, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Miami-Dade County travelers near MIA and Port of Miami."
        geoPlacename="Coral Gables, Florida"
        geoPosition="25.7215;-80.2684"
        keywords="expedited passport Coral Gables, emergency passport Coral Gables FL, same day passport Coral Gables, fast passport Miami-Dade, passport renewal Coral Gables, Coral Gables passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-14"
      />
      <div className="font-sans">
        <CoralGablesHeroSection />
        <CoralGablesStickyNav />
        <CoralGablesProcessingTimeSection />
        <CoralGablesLocalAreaSection />
        <CoralGablesServicesSection />
        <CoralGablesTravelTimingSection />
        <CoralGablesDestinationsSection />
        <CoralGablesTestimonialsSection />
        <CoralGablesAcceptanceFacilitiesSection />
        <CoralGablesComparisonSection />
        <CoralGablesMistakesSection />
        <CoralGablesHowItWorksSection />
        <CoralGablesFAQSection />
        <CoralGablesHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/coral-gables" state="FL" />
        <CoralGablesFinalCTA />
      </div>
    </>
  );
}